export const HP_IMPRESSIONS_KEY = 'HP_IMP';
export const IMPRESSION_EVENT = 'adplatform:impressions';
export const CLICK_IMPRESSION_EVENT = 'adplatform:clicks';
export const THRESHOLD_IMPRESSIONS = 20;
export const TEMP_STORAGE_KEY = 'TP_IMP';
export const VALID_THRESHOLD = 1000;
export const HP_IMPRESSIONS_KEY_V2 = 'HP_IMP_V2';
export const IMPRESSION_EVENT_V2 = 'adplatform:impressionsv2';
export const DEFAULT_ROOT_MARGIN = '0px';
export const IMPRESSION_TYPE = {
    PRODUCT: 'PRODUCT',
    BANNER: 'BANNER',
};
